import { render, staticRenderFns } from "./modalEtiqueta.vue?vue&type=template&id=67fc5b31"
import script from "./modalEtiqueta.vue?vue&type=script&lang=js"
export * from "./modalEtiqueta.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports